export const inputVariants = {
  PRIMARY: 'primary'
};
